<template>
    <section class="quote light yellow">
        <circles-layout></circles-layout>

        <v-quote>In deze nieuwe opzet bieden we maatwerk. In het eerste jaar krijgen onze studenten les van docenten zowel van Koning Willem I College als van ROC Tilburg, bijvoorbeeld zang- &eacute;n stemlessen. Hierdoor maken ze kennis met alle facetten van het artiestenvak.</v-quote>

        <v-author>- Guido Bonke, directeur School voor Kunst, Cultuur en Media van ROC Tilburg</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'RegioQuote',
        meta: {
            title: 'Regio',
            color: '#FEBE06'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
